import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import TipDialogContent from "./dialogContent";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SummerCampaignDialogContent: React.FC = () => {
  return (
    <TipDialogContent
      description={
        <Grid container direction="column" rowSpacing={2}>
          <Grid item>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TipDialogDescriptionSummer2026)}
          </Grid>
          <Grid item>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.TipDialogValiditySummer2026)}
          </Grid>
        </Grid>
      }
    />
  );
};

export default SummerCampaignDialogContent;
